import React from "react";
import { Button, Form } from "react-bootstrap";

const FormDataEntry = ({ selected }) => {
  const FIELDS = [
    { label: "Text", type: "text", placeholder: "Enter Text" },
    { label: "Number", type: "number", placeholder: "Enter Number" },
    { label: "Tel", type: "tel", placeholder: "Enter Number" },
    { label: "Date", type: "date" },
    { label: "Time", type: "time" },
    { label: "Date Time", type: "datetime-local" },
    { label: "Email", type: "email", placeholder: "Enter Email" },
    { label: "File", type: "file" },
    { label: "URL", type: "url", placeholder: "Enter URL" },
    { label: "Week", type: "week" },
    { label: "Month", type: "month" },
    { label: "Password", type: "password", placeholder: "Enter Password" },
    { label: "Radio", type: "radio" },
    { label: "Checkbox", type: "checkbox" },
    { label: "Range", type: "range" },
  ];

  return (
    <div className="">
      <div className="py-2 px-3 border-bottom border-top hstack justify-content-between">
        <h6 className="fw-bold m-0">{selected?.name}</h6>
        <Button size="sm" variant="outline-primary" style={{fontSize: 12}}>Download</Button>
      </div>
      <div className="overflow-auto" style={{height: "calc(100vh - 142px)"}}>
        {FIELDS.map(({ label, type, placeholder }) => (
          <Form.Group key={label} className="p-3 border-bottom">
            <Form.Label className="fw-bold mb-1">
              {label} <span className="text-danger">*</span>
            </Form.Label>

            {type === "radio" && (
              <>
                <Form.Check type="radio" name={label} label="Radio 1" />
                <Form.Check type="radio" name={label} label="Radio 2" />
              </>
            )}

            {type === "checkbox" && (
              <>
                <Form.Check type="checkbox" label="Checkbox 1" />
                <Form.Check type="checkbox" label="Checkbox 2" />
              </>
            )}

            {type === "range" && <Form.Range />}

            {!["radio", "checkbox", "button", "range"].includes(type) && (
              <Form.Control type={type} placeholder={placeholder} />
            )}
          </Form.Group>
        ))}
      </div>
    </div>
  );
};

export default FormDataEntry;
